<template lang="pug">
pr-wrapper(
  v-if="images.length",
  v-nv:scope="'cms-carousel'",
  :class="{ horizontal: !vertical, vertical: vertical }",
  @nv-back.native="$emit('nv-back')"
)
  .arrows-wrapper(v-if="arrows && images.length > 1", :class="[navigation]")
    .surface-bg.px-2.py-1.small.border.background.play(v-nv, @nv-enter="toggle")
      icon(:icon="isPlaying ? 'fal pause' : 'fal play'")
    .surface-bg.px-2.py-1.small.border.background.up(v-nv, @nv-enter="change('up')")
      icon(:icon="'fal chevron-up'")
    .surface-bg.px-2.py-1.small.border.background.down(v-nv, @nv-enter="change('down')")
      icon(:icon="'fal chevron-down'")
  imagec(:src="image.medium", v-if="image", :covered="covered", :vertical="vertical", @loaded="$emit('loaded', $event)")
</template>

<script>
export default {
  name: "cms-carousel",
  props: {
    images: {
      type: Array,
      default: () => []
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    arrows: {
      type: Boolean,
      default: false
    },
    navigation: {
      type: String,
      default: "vertical"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    covered: {
      type: Boolean,
      default: false
    },
    hasRoute: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      image_: 0,
      isPlaying: false,
      interval: null
    }
  },
  computed: {
    image() {
      return this.images[this.image_] || false
    }
  },
  unmounted() {
    if (this.hasRoute) return
    this.image_ = 0
    this.isPlaying = false
    this.interval = _$.removeInterval(this.interval)
  },
  mounted() {
    if (this.hasRoute) return
    this.image_ = 0
    _$.nav.sync("cms-carousel")
    if (this.autoplay && this.images.length > 1) this.toggle()
  },
  deactivated() {
    if (!this.hasRoute) return
    this.image_ = 0
    this.isPlaying = false
    this.interval = _$.removeInterval(this.interval)
  },
  activated() {
    if (!this.hasRoute) return
    this.image_ = 0
    _$.nav.sync("cms-carousel")
    if (this.autoplay && this.images.length > 1) this.toggle()
  },
  methods: {
    toggle() {
      this.isPlaying = !this.isPlaying

      if (!this.isPlaying) return (this.interval = _$.removeInterval(this.interval))

      this.interval = _$.makeInterval(async () => {
        if (this.image_ >= this.images.length - 1) this.image_ = 0
        else this.image_++
      }, 2000)
    },
    change(direction) {
      this.isPlaying = false
      this.interval = _$.removeInterval(this.interval)

      if (direction === "up") {
        if (this.image_ >= this.images.length - 1) this.image_ = 0
        else this.image_++
      } else {
        if (!this.image_) this.image_ = this.images.length - 1
        else this.image_--
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#cms-carousel {
  &.horizontal {
    width: 100%;
  }
  &.vertical {
    height: 100%;
  }
}
.arrows-wrapper {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &.horizontal {
    flex-direction: row !important;
    right: 50% !important;
    transform: translateX(50%) !important;
    margin-bottom: -1px;

    .up {
      order: 1;
      i {
        &:before {
          padding: 0 3px;
          content: "\f054";
        }
      }
    }

    .down i {
      padding: 0 3px;
      &:before {
        content: "\f053";
      }
    }
  }
}
</style>
